import { CheckoutState } from '../../state';
import { isNosDemoEnabled, isNosIntegrationEnabled } from '../splitio';
import { getNamespaceValue } from '../utils/selector';

export const getIsNosSourceOfTruth = (state: CheckoutState) =>
    isNosDemoEnabled(state) ||
    (isNosIntegrationEnabled(state) &&
        getNamespaceValue(state.order, 'isNosSourceOfTruth', false));

export const isOrderPlaced = (state: CheckoutState) =>
    getNamespaceValue(state.order, 'isPlaced', false);

export const getOrderPersistentId = (state: CheckoutState) => {
    const orderId = getNamespaceValue(state.order, 'id');
    const isOrderPlaced = getNamespaceValue(state.order, 'isPlaced', false);

    // Orders always have an ID. In LOS (Legacy Order Service) before the order is placed it is in a volatile state,
    // living in Redis. In this state the ID of the order is different than the ID after the order is placed.
    // We can distinguish both IDs because the volatile ID always begins with `O-` prefix.
    // In NOS (New Order Service) the Order Document always has the same ID, before it is confirmed and afterwards.
    return isOrderPlaced ? orderId : null;
};
